import { useFilterInitialization } from "./hooks/useFilterInitialization";
import { useFilters } from "../FilterContext";

export const AssetViewToggleFilter = () => {
	const { initialValues } = useFilters();

	useFilterInitialization("assetViewToggle", [], {
		getDefaultValue: () => {
			const storedView = initialValues.assetViewToggle;

			if (storedView && (storedView === "tree" || storedView === "list")) {
				return {
					id: storedView,
					name: storedView === "tree" ? "Tree View" : "List View",
				};
			}

			return { id: "tree", name: "Tree View" };
		},
		getParams: (viewOption) => {
			return { assetViewToggle: viewOption.id || "tree" };
		},
		waitForData: false,
	});

	// Pseudo-filter — doesn't render anything
	return null;
};
